


































import {SearchResult} from '../../models/search-result-model'
import InviewDirective from '@/shared/directives/inview-directive'
import LinkDirective from '@/shared/directives/link-directive'
import LinksDirective from '@/shared/directives/links-directive'
import {defineComponent, PropType} from "@vue/composition-api";
import {useState} from "vuex-composition-helpers";

export default defineComponent({
  name: 'ScientistSearchResultCard',
  directives: {
    InviewDirective,
    LinkDirective,
    LinksDirective
  },
  props: {
    result: {type: Object as PropType<SearchResult>},
    index: {type: Number}
  },
  setup: () => {
    const {config} = useState(['config'])

    return {
      config
    }
  }
})
